export const enMainLocale = {
  app_name: 'Reading Critters',
  app_name_possessive: "Reading Critters'",
};
